/**
 * Wyciąga czysty tekst z HTML (np. pola opisu z CMS/backendu), wstawiając spację po
 * elementach blokowych żeby "Punkt 1.Punkt 2." nie skleiły się w jedno słowo.
 *
 * Używane tam, gdzie treść trzeba przyciąć CSS-owym `-webkit-line-clamp` — ta technika
 * nie radzi sobie niezawodnie z zawartością blokową (listy, kilka akapitów) w różnych
 * silnikach/zoomach przeglądarki i potrafi nałożyć tekst na siebie. Do przyciętego
 * podglądu bezpieczniej pokazać czysty tekst; pełne, sformatowane HTML zostaje bez zmian
 * w rozwiniętym/modalowym widoku.
 */
export const stripHtml = (html: string): string => {
  if (!html) return "";

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  doc.querySelectorAll("p, li, div, br, h1, h2, h3, h4, h5, h6").forEach((el) => {
    el.insertAdjacentText("afterend", " ");
  });

  return (doc.body.textContent || "").replace(/\s+/g, " ").trim();
};
